module.exports = __webpack_public_path__ + "static/media/ico_entrega_new.ca69ceef.svg";